export function handleEvent(event: unknown) {
  if (event) {
    window.helium.events.notify({
      data: {
        type: "helium-interaction",
        name: event.name,
        ...event.properties,
      },
    });
  }
}
